import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
};
export function Button({
  children,
  href,
  className = '',
  fullWidth
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} className={`inline-flex items-center justify-center rounded-xl bg-primary px-7 py-4 text-center font-display text-base font-bold uppercase tracking-wide text-white shadow-[0_12px_28px_rgba(3,105,161,.28)] transition-colors hover:bg-primary-dark focus:outline-none focus:ring-4 focus:ring-accent/30 ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-304" data-mp="ztj3fliu8nez">
      {children}
    </motion.a>;
}